"use client";

import { useEffect, useCallback, useState } from "react";
import { useWebsocketUpdates } from "@finbackoffice/site-core";
import { IClientError, IEventFeedResponse } from "@finbackoffice/websocket-client";
import { EventStatus } from "@finbackoffice/enums";

type ICalendarGames = {
    games: IEventFeedResponse[];
    loading: boolean;
};

export const useCalendar = (date: { from: number; to: number }): ICalendarGames => {
    const [calendarFeed, setCalendarFeed] = useState<ICalendarGames>({
        games: [],
        loading: true,
    });
    const [gamesMap] = useState<Map<number, IEventFeedResponse>>(new Map());

    const handleCalendarUpdates = useCallback(
        (events: IEventFeedResponse[], error: IClientError) => {
            if (!error) {
                events.forEach((event) => {
                    if (
                        event.status === EventStatus.NotActive ||
                        event.status === EventStatus.Live
                    ) {
                        gamesMap.delete(event.id);
                    } else {
                        gamesMap.set(event.id, event);
                    }
                });
                const games = Array.from(gamesMap.values());
                setCalendarFeed({ games, loading: false });
            } else {
                console.error(error);
            }
        },
        [gamesMap, setCalendarFeed],
    );

    useEffect(() => {
        return () => {
            if (date) {
                setCalendarFeed((state) => ({
                    ...state,
                    loading: true,
                }));
                gamesMap.clear();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date]);

    useWebsocketUpdates("calendar", handleCalendarUpdates, undefined, date);

    return { games: calendarFeed.games, loading: calendarFeed.loading };
};
